




























import { Vue, Component } from 'vue-property-decorator';

import FullTemplate from '@/shared/components/Template/Full.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import OfferCardLoading from './features/Offer/components/OfferCard/OfferCardLoading.vue';
import PaymentLoading from '@/app/features/Checkout/features/Payment/PaymentLoading.vue';

@Component({
  components: {
    FullTemplate,
    ScreenSizeVisibility,
    OfferCardLoading,
    PaymentLoading
  }
})
export default class Checkout extends Vue {}
